/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * OneNext API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AcceptSuggestionResponse,
  AssistantAnalyzeJobControlResponse,
  AssistantAnalyzeJobStatus,
  AssistantAnalyzeNowBody,
  AssistantAnalyzeNowResponse,
  AssistantBriefingResponse,
  AssistantConversation,
  AssistantExecuteCardBody,
  AssistantExecuteCardResponse,
  AssistantInsightsResponse,
  AssistantSendMessageBody,
  AssistantSendMessageResponse,
  AssistantSnoozeBody,
  BillingEventsPage,
  BillingState,
  BuyCreditsBody,
  CreateEventBody,
  CreateInboxBody,
  CreateMailMessageNoteBody,
  CreateProjectBody,
  CreateTaskBody,
  DelegateTaskBody,
  DelegatedTask,
  DismissDriftAlert200,
  DriftAlert,
  EventItem,
  FlagMailMessageBody,
  GetMailPendingActionsSummary200,
  GetMailUnreadSummary200,
  HealthStatus,
  InboxItem,
  InboxItemWithSuggestions,
  ListInboxParams,
  ListMailFullSyncHistory200,
  ListMailFullSyncHistoryParams,
  ListMailMessageNotes200,
  ListMailMessagesParams,
  ListMailPendingActionsParams,
  ListMyBillingEventsParams,
  ListProjectsParams,
  ListSuggestionsParams,
  ListTasksParams,
  MailAccount,
  MailAccountInput,
  MailConnectionTest,
  MailFolder,
  MailFullSyncJob,
  MailLearnedRule,
  MailLearnedRuleInput,
  MailMessage,
  MailMessageNote,
  MailMessageWithBody,
  MailOldThreadResolveBody,
  MailOldThreadSummary,
  MailPromoteToProjectBody,
  MailTriageCorrection,
  MailTriageResponse,
  MarkMailMessageReadBody,
  MoveMailMessageBody,
  NextActionSuggestion,
  OkResponse,
  Project,
  ProjectDetail,
  ProjectSummary,
  RefuseTaskBody,
  ResolveMailOldThreadCandidates200,
  SeedResponse,
  SendMailBody,
  SendMailResult,
  SendTaskFollowupBody,
  StartMailFullSync409,
  StartMailFullSyncBody,
  SuggestedAction,
  SuggestionsDigest,
  Task,
  TaskFollowupResponse,
  TodayBundle,
  TodayNextActionSuggestion,
  TranscribeAudioBody,
  TranscriptResponse,
  TriggerDriftScan200,
  UpdateMailMessageNoteBody,
  UpdateProjectBody,
  UpdateSuggestionBody,
  UpdateTaskBody,
  UpdateTaskContextBody,
  UpgradePlanBody,
  User,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Get or sync current user
 */
export const getGetMeUrl = () => {
  return `/api/me`;
};

export const getMe = async (options?: RequestInit): Promise<User> => {
  return customFetch<User>(getGetMeUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMeQueryKey = () => {
  return [`/api/me`] as const;
};

export const getGetMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMe>>> = ({
    signal,
  }) => getMe({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMeQueryResult = NonNullable<Awaited<ReturnType<typeof getMe>>>;
export type GetMeQueryError = ErrorType<unknown>;

/**
 * @summary Get or sync current user
 */

export function useGetMe<
  TData = Awaited<ReturnType<typeof getMe>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getMe>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary List inbox items
 */
export const getListInboxUrl = (params?: ListInboxParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/inbox?${stringifiedParams}`
    : `/api/inbox`;
};

export const listInbox = async (
  params?: ListInboxParams,
  options?: RequestInit,
): Promise<InboxItem[]> => {
  return customFetch<InboxItem[]>(getListInboxUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListInboxQueryKey = (params?: ListInboxParams) => {
  return [`/api/inbox`, ...(params ? [params] : [])] as const;
};

export const getListInboxQueryOptions = <
  TData = Awaited<ReturnType<typeof listInbox>>,
  TError = ErrorType<unknown>,
>(
  params?: ListInboxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInbox>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListInboxQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listInbox>>> = ({
    signal,
  }) => listInbox(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listInbox>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListInboxQueryResult = NonNullable<
  Awaited<ReturnType<typeof listInbox>>
>;
export type ListInboxQueryError = ErrorType<unknown>;

/**
 * @summary List inbox items
 */

export function useListInbox<
  TData = Awaited<ReturnType<typeof listInbox>>,
  TError = ErrorType<unknown>,
>(
  params?: ListInboxParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listInbox>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListInboxQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create inbox item
 */
export const getCreateInboxUrl = () => {
  return `/api/inbox`;
};

export const createInbox = async (
  createInboxBody: CreateInboxBody,
  options?: RequestInit,
): Promise<InboxItem> => {
  return customFetch<InboxItem>(getCreateInboxUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createInboxBody),
  });
};

export const getCreateInboxMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInbox>>,
    TError,
    { data: BodyType<CreateInboxBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createInbox>>,
  TError,
  { data: BodyType<CreateInboxBody> },
  TContext
> => {
  const mutationKey = ["createInbox"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createInbox>>,
    { data: BodyType<CreateInboxBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createInbox(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateInboxMutationResult = NonNullable<
  Awaited<ReturnType<typeof createInbox>>
>;
export type CreateInboxMutationBody = BodyType<CreateInboxBody>;
export type CreateInboxMutationError = ErrorType<unknown>;

/**
 * @summary Create inbox item
 */
export const useCreateInbox = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createInbox>>,
    TError,
    { data: BodyType<CreateInboxBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createInbox>>,
  TError,
  { data: BodyType<CreateInboxBody> },
  TContext
> => {
  return useMutation(getCreateInboxMutationOptions(options));
};

export const getGetInboxUrl = (id: string) => {
  return `/api/inbox/${id}`;
};

export const getInbox = async (
  id: string,
  options?: RequestInit,
): Promise<InboxItemWithSuggestions> => {
  return customFetch<InboxItemWithSuggestions>(getGetInboxUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetInboxQueryKey = (id: string) => {
  return [`/api/inbox/${id}`] as const;
};

export const getGetInboxQueryOptions = <
  TData = Awaited<ReturnType<typeof getInbox>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInbox>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetInboxQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getInbox>>> = ({
    signal,
  }) => getInbox(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getInbox>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type GetInboxQueryResult = NonNullable<
  Awaited<ReturnType<typeof getInbox>>
>;
export type GetInboxQueryError = ErrorType<unknown>;

export function useGetInbox<
  TData = Awaited<ReturnType<typeof getInbox>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getInbox>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetInboxQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getArchiveInboxUrl = (id: string) => {
  return `/api/inbox/${id}`;
};

export const archiveInbox = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getArchiveInboxUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getArchiveInboxMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveInbox>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof archiveInbox>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["archiveInbox"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof archiveInbox>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return archiveInbox(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ArchiveInboxMutationResult = NonNullable<
  Awaited<ReturnType<typeof archiveInbox>>
>;

export type ArchiveInboxMutationError = ErrorType<unknown>;

export const useArchiveInbox = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof archiveInbox>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof archiveInbox>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getArchiveInboxMutationOptions(options));
};

/**
 * @summary Run AI analysis on an inbox item
 */
export const getAnalyzeInboxUrl = (id: string) => {
  return `/api/inbox/${id}/analyze`;
};

export const analyzeInbox = async (
  id: string,
  options?: RequestInit,
): Promise<InboxItemWithSuggestions> => {
  return customFetch<InboxItemWithSuggestions>(getAnalyzeInboxUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getAnalyzeInboxMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof analyzeInbox>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof analyzeInbox>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["analyzeInbox"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof analyzeInbox>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return analyzeInbox(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AnalyzeInboxMutationResult = NonNullable<
  Awaited<ReturnType<typeof analyzeInbox>>
>;

export type AnalyzeInboxMutationError = ErrorType<unknown>;

/**
 * @summary Run AI analysis on an inbox item
 */
export const useAnalyzeInbox = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof analyzeInbox>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof analyzeInbox>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getAnalyzeInboxMutationOptions(options));
};

export const getListSuggestionsUrl = (params?: ListSuggestionsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/suggestions?${stringifiedParams}`
    : `/api/suggestions`;
};

export const listSuggestions = async (
  params?: ListSuggestionsParams,
  options?: RequestInit,
): Promise<SuggestionsDigest> => {
  return customFetch<SuggestionsDigest>(getListSuggestionsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListSuggestionsQueryKey = (params?: ListSuggestionsParams) => {
  return [`/api/suggestions`, ...(params ? [params] : [])] as const;
};

export const getListSuggestionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSuggestions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSuggestionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSuggestions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSuggestionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSuggestions>>> = ({
    signal,
  }) => listSuggestions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSuggestions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListSuggestionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSuggestions>>
>;
export type ListSuggestionsQueryError = ErrorType<unknown>;

export function useListSuggestions<
  TData = Awaited<ReturnType<typeof listSuggestions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListSuggestionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listSuggestions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListSuggestionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateSuggestionUrl = (id: string) => {
  return `/api/suggestions/${id}`;
};

export const updateSuggestion = async (
  id: string,
  updateSuggestionBody: UpdateSuggestionBody,
  options?: RequestInit,
): Promise<SuggestedAction> => {
  return customFetch<SuggestedAction>(getUpdateSuggestionUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateSuggestionBody),
  });
};

export const getUpdateSuggestionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSuggestion>>,
    TError,
    { id: string; data: BodyType<UpdateSuggestionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSuggestion>>,
  TError,
  { id: string; data: BodyType<UpdateSuggestionBody> },
  TContext
> => {
  const mutationKey = ["updateSuggestion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSuggestion>>,
    { id: string; data: BodyType<UpdateSuggestionBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateSuggestion(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateSuggestionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSuggestion>>
>;
export type UpdateSuggestionMutationBody = BodyType<UpdateSuggestionBody>;
export type UpdateSuggestionMutationError = ErrorType<unknown>;

export const useUpdateSuggestion = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSuggestion>>,
    TError,
    { id: string; data: BodyType<UpdateSuggestionBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateSuggestion>>,
  TError,
  { id: string; data: BodyType<UpdateSuggestionBody> },
  TContext
> => {
  return useMutation(getUpdateSuggestionMutationOptions(options));
};

export const getAcceptSuggestionUrl = (id: string) => {
  return `/api/suggestions/${id}/accept`;
};

export const acceptSuggestion = async (
  id: string,
  options?: RequestInit,
): Promise<AcceptSuggestionResponse> => {
  return customFetch<AcceptSuggestionResponse>(getAcceptSuggestionUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getAcceptSuggestionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptSuggestion>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptSuggestion>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["acceptSuggestion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptSuggestion>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return acceptSuggestion(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptSuggestionMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptSuggestion>>
>;

export type AcceptSuggestionMutationError = ErrorType<unknown>;

export const useAcceptSuggestion = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptSuggestion>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof acceptSuggestion>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getAcceptSuggestionMutationOptions(options));
};

export const getRejectSuggestionUrl = (id: string) => {
  return `/api/suggestions/${id}/reject`;
};

export const rejectSuggestion = async (
  id: string,
  options?: RequestInit,
): Promise<SuggestedAction> => {
  return customFetch<SuggestedAction>(getRejectSuggestionUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getRejectSuggestionMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectSuggestion>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rejectSuggestion>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["rejectSuggestion"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectSuggestion>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return rejectSuggestion(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RejectSuggestionMutationResult = NonNullable<
  Awaited<ReturnType<typeof rejectSuggestion>>
>;

export type RejectSuggestionMutationError = ErrorType<unknown>;

export const useRejectSuggestion = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectSuggestion>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof rejectSuggestion>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getRejectSuggestionMutationOptions(options));
};

export const getListTasksUrl = (params?: ListTasksParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/tasks?${stringifiedParams}`
    : `/api/tasks`;
};

export const listTasks = async (
  params?: ListTasksParams,
  options?: RequestInit,
): Promise<Task[]> => {
  return customFetch<Task[]>(getListTasksUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListTasksQueryKey = (params?: ListTasksParams) => {
  return [`/api/tasks`, ...(params ? [params] : [])] as const;
};

export const getListTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof listTasks>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTasksParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTasks>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTasksQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTasks>>> = ({
    signal,
  }) => listTasks(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTasks>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListTasksQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTasks>>
>;
export type ListTasksQueryError = ErrorType<unknown>;

export function useListTasks<
  TData = Awaited<ReturnType<typeof listTasks>>,
  TError = ErrorType<unknown>,
>(
  params?: ListTasksParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listTasks>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListTasksQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateTaskUrl = () => {
  return `/api/tasks`;
};

export const createTask = async (
  createTaskBody: CreateTaskBody,
  options?: RequestInit,
): Promise<Task> => {
  return customFetch<Task>(getCreateTaskUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createTaskBody),
  });
};

export const getCreateTaskMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTask>>,
    TError,
    { data: BodyType<CreateTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTask>>,
  TError,
  { data: BodyType<CreateTaskBody> },
  TContext
> => {
  const mutationKey = ["createTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTask>>,
    { data: BodyType<CreateTaskBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createTask(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTask>>
>;
export type CreateTaskMutationBody = BodyType<CreateTaskBody>;
export type CreateTaskMutationError = ErrorType<unknown>;

export const useCreateTask = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTask>>,
    TError,
    { data: BodyType<CreateTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createTask>>,
  TError,
  { data: BodyType<CreateTaskBody> },
  TContext
> => {
  return useMutation(getCreateTaskMutationOptions(options));
};

export const getUpdateTaskUrl = (id: string) => {
  return `/api/tasks/${id}`;
};

export const updateTask = async (
  id: string,
  updateTaskBody: UpdateTaskBody,
  options?: RequestInit,
): Promise<Task> => {
  return customFetch<Task>(getUpdateTaskUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateTaskBody),
  });
};

export const getUpdateTaskMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTask>>,
    TError,
    { id: string; data: BodyType<UpdateTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTask>>,
  TError,
  { id: string; data: BodyType<UpdateTaskBody> },
  TContext
> => {
  const mutationKey = ["updateTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTask>>,
    { id: string; data: BodyType<UpdateTaskBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTask(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTask>>
>;
export type UpdateTaskMutationBody = BodyType<UpdateTaskBody>;
export type UpdateTaskMutationError = ErrorType<unknown>;

export const useUpdateTask = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTask>>,
    TError,
    { id: string; data: BodyType<UpdateTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTask>>,
  TError,
  { id: string; data: BodyType<UpdateTaskBody> },
  TContext
> => {
  return useMutation(getUpdateTaskMutationOptions(options));
};

export const getCompleteTaskUrl = (id: string) => {
  return `/api/tasks/${id}/done`;
};

export const completeTask = async (
  id: string,
  options?: RequestInit,
): Promise<Task> => {
  return customFetch<Task>(getCompleteTaskUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getCompleteTaskMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeTask>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeTask>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["completeTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeTask>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return completeTask(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeTask>>
>;

export type CompleteTaskMutationError = ErrorType<unknown>;

export const useCompleteTask = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeTask>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof completeTask>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getCompleteTaskMutationOptions(options));
};

export const getPostponeTaskUrl = (id: string) => {
  return `/api/tasks/${id}/postpone`;
};

export const postponeTask = async (
  id: string,
  options?: RequestInit,
): Promise<Task> => {
  return customFetch<Task>(getPostponeTaskUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getPostponeTaskMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postponeTask>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postponeTask>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["postponeTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postponeTask>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return postponeTask(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostponeTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof postponeTask>>
>;

export type PostponeTaskMutationError = ErrorType<unknown>;

export const usePostponeTask = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postponeTask>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof postponeTask>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getPostponeTaskMutationOptions(options));
};

export const getRefuseTaskUrl = (id: string) => {
  return `/api/tasks/${id}/refuse`;
};

export const refuseTask = async (
  id: string,
  refuseTaskBody?: RefuseTaskBody,
  options?: RequestInit,
): Promise<Task> => {
  return customFetch<Task>(getRefuseTaskUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(refuseTaskBody),
  });
};

export const getRefuseTaskMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refuseTask>>,
    TError,
    { id: string; data: BodyType<RefuseTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refuseTask>>,
  TError,
  { id: string; data: BodyType<RefuseTaskBody> },
  TContext
> => {
  const mutationKey = ["refuseTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refuseTask>>,
    { id: string; data: BodyType<RefuseTaskBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return refuseTask(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefuseTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof refuseTask>>
>;
export type RefuseTaskMutationBody = BodyType<RefuseTaskBody>;
export type RefuseTaskMutationError = ErrorType<void>;

export const useRefuseTask = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refuseTask>>,
    TError,
    { id: string; data: BodyType<RefuseTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof refuseTask>>,
  TError,
  { id: string; data: BodyType<RefuseTaskBody> },
  TContext
> => {
  return useMutation(getRefuseTaskMutationOptions(options));
};

export const getDelegateTaskUrl = (id: string) => {
  return `/api/tasks/${id}/delegate`;
};

export const delegateTask = async (
  id: string,
  delegateTaskBody: DelegateTaskBody,
  options?: RequestInit,
): Promise<Task> => {
  return customFetch<Task>(getDelegateTaskUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(delegateTaskBody),
  });
};

export const getDelegateTaskMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof delegateTask>>,
    TError,
    { id: string; data: BodyType<DelegateTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof delegateTask>>,
  TError,
  { id: string; data: BodyType<DelegateTaskBody> },
  TContext
> => {
  const mutationKey = ["delegateTask"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof delegateTask>>,
    { id: string; data: BodyType<DelegateTaskBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return delegateTask(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DelegateTaskMutationResult = NonNullable<
  Awaited<ReturnType<typeof delegateTask>>
>;
export type DelegateTaskMutationBody = BodyType<DelegateTaskBody>;
export type DelegateTaskMutationError = ErrorType<void>;

export const useDelegateTask = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof delegateTask>>,
    TError,
    { id: string; data: BodyType<DelegateTaskBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof delegateTask>>,
  TError,
  { id: string; data: BodyType<DelegateTaskBody> },
  TContext
> => {
  return useMutation(getDelegateTaskMutationOptions(options));
};

export const getUpdateTaskContextUrl = (id: string) => {
  return `/api/tasks/${id}/context`;
};

export const updateTaskContext = async (
  id: string,
  updateTaskContextBody: UpdateTaskContextBody,
  options?: RequestInit,
): Promise<Task> => {
  return customFetch<Task>(getUpdateTaskContextUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateTaskContextBody),
  });
};

export const getUpdateTaskContextMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTaskContext>>,
    TError,
    { id: string; data: BodyType<UpdateTaskContextBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTaskContext>>,
  TError,
  { id: string; data: BodyType<UpdateTaskContextBody> },
  TContext
> => {
  const mutationKey = ["updateTaskContext"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTaskContext>>,
    { id: string; data: BodyType<UpdateTaskContextBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateTaskContext(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTaskContextMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTaskContext>>
>;
export type UpdateTaskContextMutationBody = BodyType<UpdateTaskContextBody>;
export type UpdateTaskContextMutationError = ErrorType<void>;

export const useUpdateTaskContext = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTaskContext>>,
    TError,
    { id: string; data: BodyType<UpdateTaskContextBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateTaskContext>>,
  TError,
  { id: string; data: BodyType<UpdateTaskContextBody> },
  TContext
> => {
  return useMutation(getUpdateTaskContextMutationOptions(options));
};

export const getListDelegatedTasksUrl = () => {
  return `/api/tasks/delegated`;
};

export const listDelegatedTasks = async (
  options?: RequestInit,
): Promise<DelegatedTask[]> => {
  return customFetch<DelegatedTask[]>(getListDelegatedTasksUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListDelegatedTasksQueryKey = () => {
  return [`/api/tasks/delegated`] as const;
};

export const getListDelegatedTasksQueryOptions = <
  TData = Awaited<ReturnType<typeof listDelegatedTasks>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listDelegatedTasks>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDelegatedTasksQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDelegatedTasks>>
  > = ({ signal }) => listDelegatedTasks({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDelegatedTasks>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDelegatedTasksQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDelegatedTasks>>
>;
export type ListDelegatedTasksQueryError = ErrorType<unknown>;

export function useListDelegatedTasks<
  TData = Awaited<ReturnType<typeof listDelegatedTasks>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listDelegatedTasks>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListDelegatedTasksQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getSendTaskFollowupUrl = (id: string) => {
  return `/api/tasks/${id}/followup`;
};

export const sendTaskFollowup = async (
  id: string,
  sendTaskFollowupBody?: SendTaskFollowupBody,
  options?: RequestInit,
): Promise<TaskFollowupResponse> => {
  return customFetch<TaskFollowupResponse>(getSendTaskFollowupUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(sendTaskFollowupBody),
  });
};

export const getSendTaskFollowupMutationOptions = <
  TError = ErrorType<OkResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendTaskFollowup>>,
    TError,
    { id: string; data: BodyType<SendTaskFollowupBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendTaskFollowup>>,
  TError,
  { id: string; data: BodyType<SendTaskFollowupBody> },
  TContext
> => {
  const mutationKey = ["sendTaskFollowup"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendTaskFollowup>>,
    { id: string; data: BodyType<SendTaskFollowupBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return sendTaskFollowup(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendTaskFollowupMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendTaskFollowup>>
>;
export type SendTaskFollowupMutationBody = BodyType<SendTaskFollowupBody>;
export type SendTaskFollowupMutationError = ErrorType<OkResponse | void>;

export const useSendTaskFollowup = <
  TError = ErrorType<OkResponse | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendTaskFollowup>>,
    TError,
    { id: string; data: BodyType<SendTaskFollowupBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendTaskFollowup>>,
  TError,
  { id: string; data: BodyType<SendTaskFollowupBody> },
  TContext
> => {
  return useMutation(getSendTaskFollowupMutationOptions(options));
};

export const getListDriftAlertsUrl = () => {
  return `/api/drift-alerts`;
};

export const listDriftAlerts = async (
  options?: RequestInit,
): Promise<DriftAlert[]> => {
  return customFetch<DriftAlert[]>(getListDriftAlertsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListDriftAlertsQueryKey = () => {
  return [`/api/drift-alerts`] as const;
};

export const getListDriftAlertsQueryOptions = <
  TData = Awaited<ReturnType<typeof listDriftAlerts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listDriftAlerts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDriftAlertsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listDriftAlerts>>> = ({
    signal,
  }) => listDriftAlerts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDriftAlerts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDriftAlertsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDriftAlerts>>
>;
export type ListDriftAlertsQueryError = ErrorType<unknown>;

export function useListDriftAlerts<
  TData = Awaited<ReturnType<typeof listDriftAlerts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listDriftAlerts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListDriftAlertsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getDismissDriftAlertUrl = (id: string) => {
  return `/api/drift-alerts/${id}/dismiss`;
};

export const dismissDriftAlert = async (
  id: string,
  options?: RequestInit,
): Promise<DismissDriftAlert200> => {
  return customFetch<DismissDriftAlert200>(getDismissDriftAlertUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getDismissDriftAlertMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissDriftAlert>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dismissDriftAlert>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["dismissDriftAlert"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dismissDriftAlert>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return dismissDriftAlert(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DismissDriftAlertMutationResult = NonNullable<
  Awaited<ReturnType<typeof dismissDriftAlert>>
>;

export type DismissDriftAlertMutationError = ErrorType<unknown>;

export const useDismissDriftAlert = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dismissDriftAlert>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof dismissDriftAlert>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDismissDriftAlertMutationOptions(options));
};

export const getTriggerDriftScanUrl = () => {
  return `/api/drift-alerts/scan`;
};

export const triggerDriftScan = async (
  options?: RequestInit,
): Promise<TriggerDriftScan200> => {
  return customFetch<TriggerDriftScan200>(getTriggerDriftScanUrl(), {
    ...options,
    method: "POST",
  });
};

export const getTriggerDriftScanMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggerDriftScan>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof triggerDriftScan>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["triggerDriftScan"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof triggerDriftScan>>,
    void
  > = () => {
    return triggerDriftScan(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriggerDriftScanMutationResult = NonNullable<
  Awaited<ReturnType<typeof triggerDriftScan>>
>;

export type TriggerDriftScanMutationError = ErrorType<unknown>;

export const useTriggerDriftScan = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triggerDriftScan>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof triggerDriftScan>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getTriggerDriftScanMutationOptions(options));
};

export const getListProjectsUrl = (params?: ListProjectsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/projects?${stringifiedParams}`
    : `/api/projects`;
};

export const listProjects = async (
  params?: ListProjectsParams,
  options?: RequestInit,
): Promise<ProjectSummary[]> => {
  return customFetch<ProjectSummary[]>(getListProjectsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListProjectsQueryKey = (params?: ListProjectsParams) => {
  return [`/api/projects`, ...(params ? [params] : [])] as const;
};

export const getListProjectsQueryOptions = <
  TData = Awaited<ReturnType<typeof listProjects>>,
  TError = ErrorType<unknown>,
>(
  params?: ListProjectsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listProjects>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListProjectsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listProjects>>> = ({
    signal,
  }) => listProjects(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listProjects>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListProjectsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listProjects>>
>;
export type ListProjectsQueryError = ErrorType<unknown>;

export function useListProjects<
  TData = Awaited<ReturnType<typeof listProjects>>,
  TError = ErrorType<unknown>,
>(
  params?: ListProjectsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listProjects>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListProjectsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateProjectUrl = () => {
  return `/api/projects`;
};

export const createProject = async (
  createProjectBody: CreateProjectBody,
  options?: RequestInit,
): Promise<Project> => {
  return customFetch<Project>(getCreateProjectUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createProjectBody),
  });
};

export const getCreateProjectMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProject>>,
    TError,
    { data: BodyType<CreateProjectBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createProject>>,
  TError,
  { data: BodyType<CreateProjectBody> },
  TContext
> => {
  const mutationKey = ["createProject"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createProject>>,
    { data: BodyType<CreateProjectBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createProject(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof createProject>>
>;
export type CreateProjectMutationBody = BodyType<CreateProjectBody>;
export type CreateProjectMutationError = ErrorType<unknown>;

export const useCreateProject = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createProject>>,
    TError,
    { data: BodyType<CreateProjectBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createProject>>,
  TError,
  { data: BodyType<CreateProjectBody> },
  TContext
> => {
  return useMutation(getCreateProjectMutationOptions(options));
};

export const getGetProjectUrl = (id: string) => {
  return `/api/projects/${id}`;
};

export const getProject = async (
  id: string,
  options?: RequestInit,
): Promise<ProjectDetail> => {
  return customFetch<ProjectDetail>(getGetProjectUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetProjectQueryKey = (id: string) => {
  return [`/api/projects/${id}`] as const;
};

export const getGetProjectQueryOptions = <
  TData = Awaited<ReturnType<typeof getProject>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getProject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetProjectQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getProject>>> = ({
    signal,
  }) => getProject(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getProject>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetProjectQueryResult = NonNullable<
  Awaited<ReturnType<typeof getProject>>
>;
export type GetProjectQueryError = ErrorType<unknown>;

export function useGetProject<
  TData = Awaited<ReturnType<typeof getProject>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getProject>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetProjectQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpdateProjectUrl = (id: string) => {
  return `/api/projects/${id}`;
};

export const updateProject = async (
  id: string,
  updateProjectBody: UpdateProjectBody,
  options?: RequestInit,
): Promise<Project> => {
  return customFetch<Project>(getUpdateProjectUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateProjectBody),
  });
};

export const getUpdateProjectMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProject>>,
    TError,
    { id: string; data: BodyType<UpdateProjectBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateProject>>,
  TError,
  { id: string; data: BodyType<UpdateProjectBody> },
  TContext
> => {
  const mutationKey = ["updateProject"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateProject>>,
    { id: string; data: BodyType<UpdateProjectBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateProject(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateProject>>
>;
export type UpdateProjectMutationBody = BodyType<UpdateProjectBody>;
export type UpdateProjectMutationError = ErrorType<unknown>;

export const useUpdateProject = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateProject>>,
    TError,
    { id: string; data: BodyType<UpdateProjectBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateProject>>,
  TError,
  { id: string; data: BodyType<UpdateProjectBody> },
  TContext
> => {
  return useMutation(getUpdateProjectMutationOptions(options));
};

export const getSuggestNextActionUrl = (id: string) => {
  return `/api/projects/${id}/suggest-next-action`;
};

export const suggestNextAction = async (
  id: string,
  options?: RequestInit,
): Promise<NextActionSuggestion> => {
  return customFetch<NextActionSuggestion>(getSuggestNextActionUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getSuggestNextActionQueryKey = (id: string) => {
  return [`/api/projects/${id}/suggest-next-action`] as const;
};

export const getSuggestNextActionQueryOptions = <
  TData = Awaited<ReturnType<typeof suggestNextAction>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof suggestNextAction>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSuggestNextActionQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof suggestNextAction>>
  > = ({ signal }) => suggestNextAction(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof suggestNextAction>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SuggestNextActionQueryResult = NonNullable<
  Awaited<ReturnType<typeof suggestNextAction>>
>;
export type SuggestNextActionQueryError = ErrorType<unknown>;

export function useSuggestNextAction<
  TData = Awaited<ReturnType<typeof suggestNextAction>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof suggestNextAction>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSuggestNextActionQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Today recommendations
 */
export const getGetTodayUrl = () => {
  return `/api/today`;
};

export const getToday = async (options?: RequestInit): Promise<TodayBundle> => {
  return customFetch<TodayBundle>(getGetTodayUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetTodayQueryKey = () => {
  return [`/api/today`] as const;
};

export const getGetTodayQueryOptions = <
  TData = Awaited<ReturnType<typeof getToday>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getToday>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTodayQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getToday>>> = ({
    signal,
  }) => getToday({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getToday>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTodayQueryResult = NonNullable<
  Awaited<ReturnType<typeof getToday>>
>;
export type GetTodayQueryError = ErrorType<unknown>;

/**
 * @summary Today recommendations
 */

export function useGetToday<
  TData = Awaited<ReturnType<typeof getToday>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof getToday>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTodayQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Next best action suggestions for urgent tasks
 */
export const getGetTodayNextActionUrl = () => {
  return `/api/today/next-action`;
};

export const getTodayNextAction = async (
  options?: RequestInit,
): Promise<TodayNextActionSuggestion[]> => {
  return customFetch<TodayNextActionSuggestion[]>(getGetTodayNextActionUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetTodayNextActionQueryKey = () => {
  return [`/api/today/next-action`] as const;
};

export const getGetTodayNextActionQueryOptions = <
  TData = Awaited<ReturnType<typeof getTodayNextAction>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTodayNextAction>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTodayNextActionQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getTodayNextAction>>
  > = ({ signal }) => getTodayNextAction({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getTodayNextAction>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetTodayNextActionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTodayNextAction>>
>;
export type GetTodayNextActionQueryError = ErrorType<unknown>;

/**
 * @summary Next best action suggestions for urgent tasks
 */

export function useGetTodayNextAction<
  TData = Awaited<ReturnType<typeof getTodayNextAction>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getTodayNextAction>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetTodayNextActionQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Transcribe an audio file
 */
export const getTranscribeAudioUrl = () => {
  return `/api/transcribe`;
};

export const transcribeAudio = async (
  transcribeAudioBody: TranscribeAudioBody,
  options?: RequestInit,
): Promise<TranscriptResponse> => {
  const formData = new FormData();
  formData.append(`audio`, transcribeAudioBody.audio);

  return customFetch<TranscriptResponse>(getTranscribeAudioUrl(), {
    ...options,
    method: "POST",
    body: formData,
  });
};

export const getTranscribeAudioMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transcribeAudio>>,
    TError,
    { data: BodyType<TranscribeAudioBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof transcribeAudio>>,
  TError,
  { data: BodyType<TranscribeAudioBody> },
  TContext
> => {
  const mutationKey = ["transcribeAudio"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof transcribeAudio>>,
    { data: BodyType<TranscribeAudioBody> }
  > = (props) => {
    const { data } = props ?? {};

    return transcribeAudio(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TranscribeAudioMutationResult = NonNullable<
  Awaited<ReturnType<typeof transcribeAudio>>
>;
export type TranscribeAudioMutationBody = BodyType<TranscribeAudioBody>;
export type TranscribeAudioMutationError = ErrorType<unknown>;

/**
 * @summary Transcribe an audio file
 */
export const useTranscribeAudio = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transcribeAudio>>,
    TError,
    { data: BodyType<TranscribeAudioBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof transcribeAudio>>,
  TError,
  { data: BodyType<TranscribeAudioBody> },
  TContext
> => {
  return useMutation(getTranscribeAudioMutationOptions(options));
};

export const getCreateEventUrl = () => {
  return `/api/events`;
};

export const createEvent = async (
  createEventBody: CreateEventBody,
  options?: RequestInit,
): Promise<EventItem> => {
  return customFetch<EventItem>(getCreateEventUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createEventBody),
  });
};

export const getCreateEventMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEvent>>,
    TError,
    { data: BodyType<CreateEventBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEvent>>,
  TError,
  { data: BodyType<CreateEventBody> },
  TContext
> => {
  const mutationKey = ["createEvent"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEvent>>,
    { data: BodyType<CreateEventBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createEvent(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEvent>>
>;
export type CreateEventMutationBody = BodyType<CreateEventBody>;
export type CreateEventMutationError = ErrorType<unknown>;

export const useCreateEvent = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEvent>>,
    TError,
    { data: BodyType<CreateEventBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createEvent>>,
  TError,
  { data: BodyType<CreateEventBody> },
  TContext
> => {
  return useMutation(getCreateEventMutationOptions(options));
};

export const getDownloadEventIcsUrl = (id: string) => {
  return `/api/events/${id}/ics`;
};

export const downloadEventIcs = async (
  id: string,
  options?: RequestInit,
): Promise<string> => {
  return customFetch<string>(getDownloadEventIcsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getDownloadEventIcsQueryKey = (id: string) => {
  return [`/api/events/${id}/ics`] as const;
};

export const getDownloadEventIcsQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadEventIcs>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadEventIcs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDownloadEventIcsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadEventIcs>>
  > = ({ signal }) => downloadEventIcs(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadEventIcs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadEventIcsQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadEventIcs>>
>;
export type DownloadEventIcsQueryError = ErrorType<unknown>;

export function useDownloadEventIcs<
  TData = Awaited<ReturnType<typeof downloadEventIcs>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadEventIcs>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadEventIcsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetMailUnreadSummaryUrl = () => {
  return `/api/mail/unread-summary`;
};

export const getMailUnreadSummary = async (
  options?: RequestInit,
): Promise<GetMailUnreadSummary200> => {
  return customFetch<GetMailUnreadSummary200>(getGetMailUnreadSummaryUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetMailUnreadSummaryQueryKey = () => {
  return [`/api/mail/unread-summary`] as const;
};

export const getGetMailUnreadSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getMailUnreadSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMailUnreadSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMailUnreadSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMailUnreadSummary>>
  > = ({ signal }) => getMailUnreadSummary({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMailUnreadSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMailUnreadSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMailUnreadSummary>>
>;
export type GetMailUnreadSummaryQueryError = ErrorType<unknown>;

export function useGetMailUnreadSummary<
  TData = Awaited<ReturnType<typeof getMailUnreadSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMailUnreadSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMailUnreadSummaryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Cross-account list of action_required mails (À faire view)
 */
export const getListMailPendingActionsUrl = (
  params?: ListMailPendingActionsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/mail/pending-actions?${stringifiedParams}`
    : `/api/mail/pending-actions`;
};

export const listMailPendingActions = async (
  params?: ListMailPendingActionsParams,
  options?: RequestInit,
): Promise<MailMessage[]> => {
  return customFetch<MailMessage[]>(getListMailPendingActionsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListMailPendingActionsQueryKey = (
  params?: ListMailPendingActionsParams,
) => {
  return [`/api/mail/pending-actions`, ...(params ? [params] : [])] as const;
};

export const getListMailPendingActionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMailPendingActions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMailPendingActionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMailPendingActions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListMailPendingActionsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMailPendingActions>>
  > = ({ signal }) =>
    listMailPendingActions(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMailPendingActions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMailPendingActionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMailPendingActions>>
>;
export type ListMailPendingActionsQueryError = ErrorType<unknown>;

/**
 * @summary Cross-account list of action_required mails (À faire view)
 */

export function useListMailPendingActions<
  TData = Awaited<ReturnType<typeof listMailPendingActions>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMailPendingActionsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMailPendingActions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMailPendingActionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Total count of pending action mails (sidebar badge)
 */
export const getGetMailPendingActionsSummaryUrl = () => {
  return `/api/mail/pending-actions/summary`;
};

export const getMailPendingActionsSummary = async (
  options?: RequestInit,
): Promise<GetMailPendingActionsSummary200> => {
  return customFetch<GetMailPendingActionsSummary200>(
    getGetMailPendingActionsSummaryUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetMailPendingActionsSummaryQueryKey = () => {
  return [`/api/mail/pending-actions/summary`] as const;
};

export const getGetMailPendingActionsSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getMailPendingActionsSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMailPendingActionsSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMailPendingActionsSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMailPendingActionsSummary>>
  > = ({ signal }) =>
    getMailPendingActionsSummary({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMailPendingActionsSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMailPendingActionsSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMailPendingActionsSummary>>
>;
export type GetMailPendingActionsSummaryQueryError = ErrorType<unknown>;

/**
 * @summary Total count of pending action mails (sidebar badge)
 */

export function useGetMailPendingActionsSummary<
  TData = Awaited<ReturnType<typeof getMailPendingActionsSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMailPendingActionsSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMailPendingActionsSummaryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getListMailAccountsUrl = () => {
  return `/api/mail/accounts`;
};

export const listMailAccounts = async (
  options?: RequestInit,
): Promise<MailAccount[]> => {
  return customFetch<MailAccount[]>(getListMailAccountsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListMailAccountsQueryKey = () => {
  return [`/api/mail/accounts`] as const;
};

export const getListMailAccountsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMailAccounts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMailAccounts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMailAccountsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMailAccounts>>
  > = ({ signal }) => listMailAccounts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMailAccounts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMailAccountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMailAccounts>>
>;
export type ListMailAccountsQueryError = ErrorType<unknown>;

export function useListMailAccounts<
  TData = Awaited<ReturnType<typeof listMailAccounts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listMailAccounts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMailAccountsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateMailAccountUrl = () => {
  return `/api/mail/accounts`;
};

export const createMailAccount = async (
  mailAccountInput: MailAccountInput,
  options?: RequestInit,
): Promise<MailAccount> => {
  return customFetch<MailAccount>(getCreateMailAccountUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(mailAccountInput),
  });
};

export const getCreateMailAccountMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMailAccount>>,
    TError,
    { data: BodyType<MailAccountInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMailAccount>>,
  TError,
  { data: BodyType<MailAccountInput> },
  TContext
> => {
  const mutationKey = ["createMailAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMailAccount>>,
    { data: BodyType<MailAccountInput> }
  > = (props) => {
    const { data } = props ?? {};

    return createMailAccount(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMailAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMailAccount>>
>;
export type CreateMailAccountMutationBody = BodyType<MailAccountInput>;
export type CreateMailAccountMutationError = ErrorType<unknown>;

export const useCreateMailAccount = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMailAccount>>,
    TError,
    { data: BodyType<MailAccountInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMailAccount>>,
  TError,
  { data: BodyType<MailAccountInput> },
  TContext
> => {
  return useMutation(getCreateMailAccountMutationOptions(options));
};

export const getTestMailAccountUrl = () => {
  return `/api/mail/accounts/test`;
};

export const testMailAccount = async (
  mailAccountInput: MailAccountInput,
  options?: RequestInit,
): Promise<MailConnectionTest> => {
  return customFetch<MailConnectionTest>(getTestMailAccountUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(mailAccountInput),
  });
};

export const getTestMailAccountMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testMailAccount>>,
    TError,
    { data: BodyType<MailAccountInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof testMailAccount>>,
  TError,
  { data: BodyType<MailAccountInput> },
  TContext
> => {
  const mutationKey = ["testMailAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof testMailAccount>>,
    { data: BodyType<MailAccountInput> }
  > = (props) => {
    const { data } = props ?? {};

    return testMailAccount(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TestMailAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof testMailAccount>>
>;
export type TestMailAccountMutationBody = BodyType<MailAccountInput>;
export type TestMailAccountMutationError = ErrorType<unknown>;

export const useTestMailAccount = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof testMailAccount>>,
    TError,
    { data: BodyType<MailAccountInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof testMailAccount>>,
  TError,
  { data: BodyType<MailAccountInput> },
  TContext
> => {
  return useMutation(getTestMailAccountMutationOptions(options));
};

export const getUpdateMailAccountUrl = (id: string) => {
  return `/api/mail/accounts/${id}`;
};

export const updateMailAccount = async (
  id: string,
  mailAccountInput: MailAccountInput,
  options?: RequestInit,
): Promise<MailAccount> => {
  return customFetch<MailAccount>(getUpdateMailAccountUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(mailAccountInput),
  });
};

export const getUpdateMailAccountMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMailAccount>>,
    TError,
    { id: string; data: BodyType<MailAccountInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMailAccount>>,
  TError,
  { id: string; data: BodyType<MailAccountInput> },
  TContext
> => {
  const mutationKey = ["updateMailAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMailAccount>>,
    { id: string; data: BodyType<MailAccountInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateMailAccount(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMailAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMailAccount>>
>;
export type UpdateMailAccountMutationBody = BodyType<MailAccountInput>;
export type UpdateMailAccountMutationError = ErrorType<unknown>;

export const useUpdateMailAccount = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMailAccount>>,
    TError,
    { id: string; data: BodyType<MailAccountInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMailAccount>>,
  TError,
  { id: string; data: BodyType<MailAccountInput> },
  TContext
> => {
  return useMutation(getUpdateMailAccountMutationOptions(options));
};

export const getDeleteMailAccountUrl = (id: string) => {
  return `/api/mail/accounts/${id}`;
};

export const deleteMailAccount = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteMailAccountUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteMailAccountMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMailAccount>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMailAccount>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteMailAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMailAccount>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteMailAccount(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMailAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMailAccount>>
>;

export type DeleteMailAccountMutationError = ErrorType<unknown>;

export const useDeleteMailAccount = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMailAccount>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMailAccount>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteMailAccountMutationOptions(options));
};

export const getSyncMailAccountUrl = (id: string) => {
  return `/api/mail/accounts/${id}/sync`;
};

export const syncMailAccount = async (
  id: string,
  options?: RequestInit,
): Promise<MailAccount> => {
  return customFetch<MailAccount>(getSyncMailAccountUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getSyncMailAccountMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncMailAccount>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof syncMailAccount>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["syncMailAccount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof syncMailAccount>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return syncMailAccount(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SyncMailAccountMutationResult = NonNullable<
  Awaited<ReturnType<typeof syncMailAccount>>
>;

export type SyncMailAccountMutationError = ErrorType<unknown>;

export const useSyncMailAccount = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncMailAccount>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof syncMailAccount>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getSyncMailAccountMutationOptions(options));
};

/**
 * Returns the latest full-history sync job for the account, or 204 if none was ever requested.
 */
export const getGetMailFullSyncStatusUrl = (id: string) => {
  return `/api/mail/accounts/${id}/full-sync`;
};

export const getMailFullSyncStatus = async (
  id: string,
  options?: RequestInit,
): Promise<MailFullSyncJob | void> => {
  return customFetch<MailFullSyncJob | void>(getGetMailFullSyncStatusUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetMailFullSyncStatusQueryKey = (id: string) => {
  return [`/api/mail/accounts/${id}/full-sync`] as const;
};

export const getGetMailFullSyncStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getMailFullSyncStatus>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMailFullSyncStatus>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMailFullSyncStatusQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMailFullSyncStatus>>
  > = ({ signal }) => getMailFullSyncStatus(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMailFullSyncStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMailFullSyncStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMailFullSyncStatus>>
>;
export type GetMailFullSyncStatusQueryError = ErrorType<unknown>;

export function useGetMailFullSyncStatus<
  TData = Awaited<ReturnType<typeof getMailFullSyncStatus>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMailFullSyncStatus>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMailFullSyncStatusQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Start (or replace) a deep history sync for the account. The sync runs in the background and progress is pushed via SSE on /mail/events.
 */
export const getStartMailFullSyncUrl = (id: string) => {
  return `/api/mail/accounts/${id}/full-sync`;
};

export const startMailFullSync = async (
  id: string,
  startMailFullSyncBody: StartMailFullSyncBody,
  options?: RequestInit,
): Promise<MailFullSyncJob> => {
  return customFetch<MailFullSyncJob>(getStartMailFullSyncUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(startMailFullSyncBody),
  });
};

export const getStartMailFullSyncMutationOptions = <
  TError = ErrorType<StartMailFullSync409>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startMailFullSync>>,
    TError,
    { id: string; data: BodyType<StartMailFullSyncBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startMailFullSync>>,
  TError,
  { id: string; data: BodyType<StartMailFullSyncBody> },
  TContext
> => {
  const mutationKey = ["startMailFullSync"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startMailFullSync>>,
    { id: string; data: BodyType<StartMailFullSyncBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return startMailFullSync(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartMailFullSyncMutationResult = NonNullable<
  Awaited<ReturnType<typeof startMailFullSync>>
>;
export type StartMailFullSyncMutationBody = BodyType<StartMailFullSyncBody>;
export type StartMailFullSyncMutationError = ErrorType<StartMailFullSync409>;

export const useStartMailFullSync = <
  TError = ErrorType<StartMailFullSync409>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startMailFullSync>>,
    TError,
    { id: string; data: BodyType<StartMailFullSyncBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof startMailFullSync>>,
  TError,
  { id: string; data: BodyType<StartMailFullSyncBody> },
  TContext
> => {
  return useMutation(getStartMailFullSyncMutationOptions(options));
};

export const getPauseMailFullSyncUrl = (id: string) => {
  return `/api/mail/accounts/${id}/full-sync/pause`;
};

export const pauseMailFullSync = async (
  id: string,
  options?: RequestInit,
): Promise<MailFullSyncJob> => {
  return customFetch<MailFullSyncJob>(getPauseMailFullSyncUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getPauseMailFullSyncMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pauseMailFullSync>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof pauseMailFullSync>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["pauseMailFullSync"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof pauseMailFullSync>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return pauseMailFullSync(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PauseMailFullSyncMutationResult = NonNullable<
  Awaited<ReturnType<typeof pauseMailFullSync>>
>;

export type PauseMailFullSyncMutationError = ErrorType<unknown>;

export const usePauseMailFullSync = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pauseMailFullSync>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof pauseMailFullSync>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getPauseMailFullSyncMutationOptions(options));
};

export const getResumeMailFullSyncUrl = (id: string) => {
  return `/api/mail/accounts/${id}/full-sync/resume`;
};

export const resumeMailFullSync = async (
  id: string,
  options?: RequestInit,
): Promise<MailFullSyncJob> => {
  return customFetch<MailFullSyncJob>(getResumeMailFullSyncUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getResumeMailFullSyncMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resumeMailFullSync>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resumeMailFullSync>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["resumeMailFullSync"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resumeMailFullSync>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return resumeMailFullSync(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResumeMailFullSyncMutationResult = NonNullable<
  Awaited<ReturnType<typeof resumeMailFullSync>>
>;

export type ResumeMailFullSyncMutationError = ErrorType<unknown>;

export const useResumeMailFullSync = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resumeMailFullSync>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resumeMailFullSync>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getResumeMailFullSyncMutationOptions(options));
};

export const getCancelMailFullSyncUrl = (id: string) => {
  return `/api/mail/accounts/${id}/full-sync/cancel`;
};

export const cancelMailFullSync = async (
  id: string,
  options?: RequestInit,
): Promise<MailFullSyncJob> => {
  return customFetch<MailFullSyncJob>(getCancelMailFullSyncUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getCancelMailFullSyncMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelMailFullSync>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelMailFullSync>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["cancelMailFullSync"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelMailFullSync>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return cancelMailFullSync(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelMailFullSyncMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelMailFullSync>>
>;

export type CancelMailFullSyncMutationError = ErrorType<unknown>;

export const useCancelMailFullSync = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelMailFullSync>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelMailFullSync>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getCancelMailFullSyncMutationOptions(options));
};

/**
 * Returns the most recent finished full-sync jobs for an account
(newest first). Use to display "Historique des synchros" in the
Settings UI.

 */
export const getListMailFullSyncHistoryUrl = (
  id: string,
  params?: ListMailFullSyncHistoryParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/mail/accounts/${id}/full-sync/history?${stringifiedParams}`
    : `/api/mail/accounts/${id}/full-sync/history`;
};

export const listMailFullSyncHistory = async (
  id: string,
  params?: ListMailFullSyncHistoryParams,
  options?: RequestInit,
): Promise<ListMailFullSyncHistory200> => {
  return customFetch<ListMailFullSyncHistory200>(
    getListMailFullSyncHistoryUrl(id, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListMailFullSyncHistoryQueryKey = (
  id: string,
  params?: ListMailFullSyncHistoryParams,
) => {
  return [
    `/api/mail/accounts/${id}/full-sync/history`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListMailFullSyncHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof listMailFullSyncHistory>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: ListMailFullSyncHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMailFullSyncHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListMailFullSyncHistoryQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMailFullSyncHistory>>
  > = ({ signal }) =>
    listMailFullSyncHistory(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listMailFullSyncHistory>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMailFullSyncHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMailFullSyncHistory>>
>;
export type ListMailFullSyncHistoryQueryError = ErrorType<unknown>;

export function useListMailFullSyncHistory<
  TData = Awaited<ReturnType<typeof listMailFullSyncHistory>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: ListMailFullSyncHistoryParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMailFullSyncHistory>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMailFullSyncHistoryQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getListMailFoldersUrl = (id: string) => {
  return `/api/mail/accounts/${id}/folders`;
};

export const listMailFolders = async (
  id: string,
  options?: RequestInit,
): Promise<MailFolder[]> => {
  return customFetch<MailFolder[]>(getListMailFoldersUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListMailFoldersQueryKey = (id: string) => {
  return [`/api/mail/accounts/${id}/folders`] as const;
};

export const getListMailFoldersQueryOptions = <
  TData = Awaited<ReturnType<typeof listMailFolders>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMailFolders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMailFoldersQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMailFolders>>> = ({
    signal,
  }) => listMailFolders(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listMailFolders>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMailFoldersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMailFolders>>
>;
export type ListMailFoldersQueryError = ErrorType<unknown>;

export function useListMailFolders<
  TData = Awaited<ReturnType<typeof listMailFolders>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMailFolders>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMailFoldersQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getSyncMailFolderUrl = (id: string) => {
  return `/api/mail/folders/${id}/sync`;
};

export const syncMailFolder = async (
  id: string,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getSyncMailFolderUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getSyncMailFolderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncMailFolder>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof syncMailFolder>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["syncMailFolder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof syncMailFolder>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return syncMailFolder(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SyncMailFolderMutationResult = NonNullable<
  Awaited<ReturnType<typeof syncMailFolder>>
>;

export type SyncMailFolderMutationError = ErrorType<unknown>;

export const useSyncMailFolder = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof syncMailFolder>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof syncMailFolder>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getSyncMailFolderMutationOptions(options));
};

export const getListMailMessagesUrl = (
  id: string,
  params?: ListMailMessagesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/mail/accounts/${id}/messages?${stringifiedParams}`
    : `/api/mail/accounts/${id}/messages`;
};

export const listMailMessages = async (
  id: string,
  params?: ListMailMessagesParams,
  options?: RequestInit,
): Promise<MailMessage[]> => {
  return customFetch<MailMessage[]>(getListMailMessagesUrl(id, params), {
    ...options,
    method: "GET",
  });
};

export const getListMailMessagesQueryKey = (
  id: string,
  params?: ListMailMessagesParams,
) => {
  return [
    `/api/mail/accounts/${id}/messages`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListMailMessagesQueryOptions = <
  TData = Awaited<ReturnType<typeof listMailMessages>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: ListMailMessagesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMailMessages>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListMailMessagesQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMailMessages>>
  > = ({ signal }) =>
    listMailMessages(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listMailMessages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMailMessagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMailMessages>>
>;
export type ListMailMessagesQueryError = ErrorType<unknown>;

export function useListMailMessages<
  TData = Awaited<ReturnType<typeof listMailMessages>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: ListMailMessagesParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMailMessages>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMailMessagesQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getSendMailMessageUrl = (id: string) => {
  return `/api/mail/accounts/${id}/send`;
};

export const sendMailMessage = async (
  id: string,
  sendMailBody: SendMailBody,
  options?: RequestInit,
): Promise<SendMailResult> => {
  return customFetch<SendMailResult>(getSendMailMessageUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(sendMailBody),
  });
};

export const getSendMailMessageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMailMessage>>,
    TError,
    { id: string; data: BodyType<SendMailBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendMailMessage>>,
  TError,
  { id: string; data: BodyType<SendMailBody> },
  TContext
> => {
  const mutationKey = ["sendMailMessage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendMailMessage>>,
    { id: string; data: BodyType<SendMailBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return sendMailMessage(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendMailMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendMailMessage>>
>;
export type SendMailMessageMutationBody = BodyType<SendMailBody>;
export type SendMailMessageMutationError = ErrorType<unknown>;

export const useSendMailMessage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMailMessage>>,
    TError,
    { id: string; data: BodyType<SendMailBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendMailMessage>>,
  TError,
  { id: string; data: BodyType<SendMailBody> },
  TContext
> => {
  return useMutation(getSendMailMessageMutationOptions(options));
};

export const getGetMailMessageUrl = (id: string) => {
  return `/api/mail/messages/${id}`;
};

export const getMailMessage = async (
  id: string,
  options?: RequestInit,
): Promise<MailMessageWithBody> => {
  return customFetch<MailMessageWithBody>(getGetMailMessageUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetMailMessageQueryKey = (id: string) => {
  return [`/api/mail/messages/${id}`] as const;
};

export const getGetMailMessageQueryOptions = <
  TData = Awaited<ReturnType<typeof getMailMessage>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMailMessage>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMailMessageQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMailMessage>>> = ({
    signal,
  }) => getMailMessage(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getMailMessage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMailMessageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMailMessage>>
>;
export type GetMailMessageQueryError = ErrorType<unknown>;

export function useGetMailMessage<
  TData = Awaited<ReturnType<typeof getMailMessage>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getMailMessage>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetMailMessageQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getDeleteMailMessageUrl = (id: string) => {
  return `/api/mail/messages/${id}`;
};

export const deleteMailMessage = async (
  id: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteMailMessageUrl(id), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteMailMessageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMailMessage>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMailMessage>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteMailMessage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMailMessage>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteMailMessage(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMailMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMailMessage>>
>;

export type DeleteMailMessageMutationError = ErrorType<unknown>;

export const useDeleteMailMessage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMailMessage>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMailMessage>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getDeleteMailMessageMutationOptions(options));
};

export const getMarkMailMessageReadUrl = (id: string) => {
  return `/api/mail/messages/${id}/read`;
};

export const markMailMessageRead = async (
  id: string,
  markMailMessageReadBody?: MarkMailMessageReadBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getMarkMailMessageReadUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(markMailMessageReadBody),
  });
};

export const getMarkMailMessageReadMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markMailMessageRead>>,
    TError,
    { id: string; data: BodyType<MarkMailMessageReadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markMailMessageRead>>,
  TError,
  { id: string; data: BodyType<MarkMailMessageReadBody> },
  TContext
> => {
  const mutationKey = ["markMailMessageRead"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markMailMessageRead>>,
    { id: string; data: BodyType<MarkMailMessageReadBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return markMailMessageRead(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkMailMessageReadMutationResult = NonNullable<
  Awaited<ReturnType<typeof markMailMessageRead>>
>;
export type MarkMailMessageReadMutationBody = BodyType<MarkMailMessageReadBody>;
export type MarkMailMessageReadMutationError = ErrorType<unknown>;

export const useMarkMailMessageRead = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markMailMessageRead>>,
    TError,
    { id: string; data: BodyType<MarkMailMessageReadBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markMailMessageRead>>,
  TError,
  { id: string; data: BodyType<MarkMailMessageReadBody> },
  TContext
> => {
  return useMutation(getMarkMailMessageReadMutationOptions(options));
};

export const getFlagMailMessageUrl = (id: string) => {
  return `/api/mail/messages/${id}/flag`;
};

export const flagMailMessage = async (
  id: string,
  flagMailMessageBody?: FlagMailMessageBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getFlagMailMessageUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(flagMailMessageBody),
  });
};

export const getFlagMailMessageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof flagMailMessage>>,
    TError,
    { id: string; data: BodyType<FlagMailMessageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof flagMailMessage>>,
  TError,
  { id: string; data: BodyType<FlagMailMessageBody> },
  TContext
> => {
  const mutationKey = ["flagMailMessage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof flagMailMessage>>,
    { id: string; data: BodyType<FlagMailMessageBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return flagMailMessage(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type FlagMailMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof flagMailMessage>>
>;
export type FlagMailMessageMutationBody = BodyType<FlagMailMessageBody>;
export type FlagMailMessageMutationError = ErrorType<unknown>;

export const useFlagMailMessage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof flagMailMessage>>,
    TError,
    { id: string; data: BodyType<FlagMailMessageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof flagMailMessage>>,
  TError,
  { id: string; data: BodyType<FlagMailMessageBody> },
  TContext
> => {
  return useMutation(getFlagMailMessageMutationOptions(options));
};

/**
 * @summary Locally mark a message as Answered (À faire "Répondu")
 */
export const getMarkMailMessageRepliedUrl = (id: string) => {
  return `/api/mail/messages/${id}/mark-replied`;
};

export const markMailMessageReplied = async (
  id: string,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getMarkMailMessageRepliedUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getMarkMailMessageRepliedMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markMailMessageReplied>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof markMailMessageReplied>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["markMailMessageReplied"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof markMailMessageReplied>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return markMailMessageReplied(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkMailMessageRepliedMutationResult = NonNullable<
  Awaited<ReturnType<typeof markMailMessageReplied>>
>;

export type MarkMailMessageRepliedMutationError = ErrorType<unknown>;

/**
 * @summary Locally mark a message as Answered (À faire "Répondu")
 */
export const useMarkMailMessageReplied = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof markMailMessageReplied>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof markMailMessageReplied>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getMarkMailMessageRepliedMutationOptions(options));
};

/**
 * @summary List user-authored annotations attached to a mail message
 */
export const getListMailMessageNotesUrl = (id: string) => {
  return `/api/mail/messages/${id}/notes`;
};

export const listMailMessageNotes = async (
  id: string,
  options?: RequestInit,
): Promise<ListMailMessageNotes200> => {
  return customFetch<ListMailMessageNotes200>(getListMailMessageNotesUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListMailMessageNotesQueryKey = (id: string) => {
  return [`/api/mail/messages/${id}/notes`] as const;
};

export const getListMailMessageNotesQueryOptions = <
  TData = Awaited<ReturnType<typeof listMailMessageNotes>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMailMessageNotes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListMailMessageNotesQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMailMessageNotes>>
  > = ({ signal }) => listMailMessageNotes(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listMailMessageNotes>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMailMessageNotesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMailMessageNotes>>
>;
export type ListMailMessageNotesQueryError = ErrorType<unknown>;

/**
 * @summary List user-authored annotations attached to a mail message
 */

export function useListMailMessageNotes<
  TData = Awaited<ReturnType<typeof listMailMessageNotes>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMailMessageNotes>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMailMessageNotesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Add an annotation to a mail message
 */
export const getCreateMailMessageNoteUrl = (id: string) => {
  return `/api/mail/messages/${id}/notes`;
};

export const createMailMessageNote = async (
  id: string,
  createMailMessageNoteBody: CreateMailMessageNoteBody,
  options?: RequestInit,
): Promise<MailMessageNote> => {
  return customFetch<MailMessageNote>(getCreateMailMessageNoteUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(createMailMessageNoteBody),
  });
};

export const getCreateMailMessageNoteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMailMessageNote>>,
    TError,
    { id: string; data: BodyType<CreateMailMessageNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMailMessageNote>>,
  TError,
  { id: string; data: BodyType<CreateMailMessageNoteBody> },
  TContext
> => {
  const mutationKey = ["createMailMessageNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMailMessageNote>>,
    { id: string; data: BodyType<CreateMailMessageNoteBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createMailMessageNote(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMailMessageNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMailMessageNote>>
>;
export type CreateMailMessageNoteMutationBody =
  BodyType<CreateMailMessageNoteBody>;
export type CreateMailMessageNoteMutationError = ErrorType<unknown>;

/**
 * @summary Add an annotation to a mail message
 */
export const useCreateMailMessageNote = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMailMessageNote>>,
    TError,
    { id: string; data: BodyType<CreateMailMessageNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMailMessageNote>>,
  TError,
  { id: string; data: BodyType<CreateMailMessageNoteBody> },
  TContext
> => {
  return useMutation(getCreateMailMessageNoteMutationOptions(options));
};

/**
 * @summary Edit the content of an annotation
 */
export const getUpdateMailMessageNoteUrl = (id: string, noteId: string) => {
  return `/api/mail/messages/${id}/notes/${noteId}`;
};

export const updateMailMessageNote = async (
  id: string,
  noteId: string,
  updateMailMessageNoteBody: UpdateMailMessageNoteBody,
  options?: RequestInit,
): Promise<MailMessageNote> => {
  return customFetch<MailMessageNote>(getUpdateMailMessageNoteUrl(id, noteId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateMailMessageNoteBody),
  });
};

export const getUpdateMailMessageNoteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMailMessageNote>>,
    TError,
    { id: string; noteId: string; data: BodyType<UpdateMailMessageNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMailMessageNote>>,
  TError,
  { id: string; noteId: string; data: BodyType<UpdateMailMessageNoteBody> },
  TContext
> => {
  const mutationKey = ["updateMailMessageNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMailMessageNote>>,
    { id: string; noteId: string; data: BodyType<UpdateMailMessageNoteBody> }
  > = (props) => {
    const { id, noteId, data } = props ?? {};

    return updateMailMessageNote(id, noteId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMailMessageNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMailMessageNote>>
>;
export type UpdateMailMessageNoteMutationBody =
  BodyType<UpdateMailMessageNoteBody>;
export type UpdateMailMessageNoteMutationError = ErrorType<unknown>;

/**
 * @summary Edit the content of an annotation
 */
export const useUpdateMailMessageNote = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMailMessageNote>>,
    TError,
    { id: string; noteId: string; data: BodyType<UpdateMailMessageNoteBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateMailMessageNote>>,
  TError,
  { id: string; noteId: string; data: BodyType<UpdateMailMessageNoteBody> },
  TContext
> => {
  return useMutation(getUpdateMailMessageNoteMutationOptions(options));
};

/**
 * @summary Remove an annotation
 */
export const getDeleteMailMessageNoteUrl = (id: string, noteId: string) => {
  return `/api/mail/messages/${id}/notes/${noteId}`;
};

export const deleteMailMessageNote = async (
  id: string,
  noteId: string,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getDeleteMailMessageNoteUrl(id, noteId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteMailMessageNoteMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMailMessageNote>>,
    TError,
    { id: string; noteId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMailMessageNote>>,
  TError,
  { id: string; noteId: string },
  TContext
> => {
  const mutationKey = ["deleteMailMessageNote"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMailMessageNote>>,
    { id: string; noteId: string }
  > = (props) => {
    const { id, noteId } = props ?? {};

    return deleteMailMessageNote(id, noteId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMailMessageNoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMailMessageNote>>
>;

export type DeleteMailMessageNoteMutationError = ErrorType<unknown>;

/**
 * @summary Remove an annotation
 */
export const useDeleteMailMessageNote = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMailMessageNote>>,
    TError,
    { id: string; noteId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMailMessageNote>>,
  TError,
  { id: string; noteId: string },
  TContext
> => {
  return useMutation(getDeleteMailMessageNoteMutationOptions(options));
};

export const getMoveMailMessageUrl = (id: string) => {
  return `/api/mail/messages/${id}/move`;
};

export const moveMailMessage = async (
  id: string,
  moveMailMessageBody: MoveMailMessageBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getMoveMailMessageUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(moveMailMessageBody),
  });
};

export const getMoveMailMessageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof moveMailMessage>>,
    TError,
    { id: string; data: BodyType<MoveMailMessageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof moveMailMessage>>,
  TError,
  { id: string; data: BodyType<MoveMailMessageBody> },
  TContext
> => {
  const mutationKey = ["moveMailMessage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof moveMailMessage>>,
    { id: string; data: BodyType<MoveMailMessageBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return moveMailMessage(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MoveMailMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof moveMailMessage>>
>;
export type MoveMailMessageMutationBody = BodyType<MoveMailMessageBody>;
export type MoveMailMessageMutationError = ErrorType<unknown>;

export const useMoveMailMessage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof moveMailMessage>>,
    TError,
    { id: string; data: BodyType<MoveMailMessageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof moveMailMessage>>,
  TError,
  { id: string; data: BodyType<MoveMailMessageBody> },
  TContext
> => {
  return useMutation(getMoveMailMessageMutationOptions(options));
};

export const getAnalyzeMailMessageUrl = (id: string) => {
  return `/api/mail/messages/${id}/analyze`;
};

export const analyzeMailMessage = async (
  id: string,
  options?: RequestInit,
): Promise<InboxItemWithSuggestions> => {
  return customFetch<InboxItemWithSuggestions>(getAnalyzeMailMessageUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getAnalyzeMailMessageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof analyzeMailMessage>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof analyzeMailMessage>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["analyzeMailMessage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof analyzeMailMessage>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return analyzeMailMessage(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AnalyzeMailMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof analyzeMailMessage>>
>;

export type AnalyzeMailMessageMutationError = ErrorType<unknown>;

export const useAnalyzeMailMessage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof analyzeMailMessage>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof analyzeMailMessage>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getAnalyzeMailMessageMutationOptions(options));
};

/**
 * @summary Re-run AI triage on a single message (manual override of the cap is NOT allowed).
 */
export const getTriageMailMessageUrl = (id: string) => {
  return `/api/mail/messages/${id}/triage`;
};

export const triageMailMessage = async (
  id: string,
  options?: RequestInit,
): Promise<MailTriageResponse> => {
  return customFetch<MailTriageResponse>(getTriageMailMessageUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getTriageMailMessageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triageMailMessage>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof triageMailMessage>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["triageMailMessage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof triageMailMessage>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return triageMailMessage(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TriageMailMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof triageMailMessage>>
>;

export type TriageMailMessageMutationError = ErrorType<unknown>;

/**
 * @summary Re-run AI triage on a single message (manual override of the cap is NOT allowed).
 */
export const useTriageMailMessage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof triageMailMessage>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof triageMailMessage>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getTriageMailMessageMutationOptions(options));
};

/**
 * @summary User correction of a triage label, optionally creating a learned rule.
 */
export const getCorrectMailMessageTriageUrl = (id: string) => {
  return `/api/mail/messages/${id}/correct`;
};

export const correctMailMessageTriage = async (
  id: string,
  mailTriageCorrection: MailTriageCorrection,
  options?: RequestInit,
): Promise<MailMessage> => {
  return customFetch<MailMessage>(getCorrectMailMessageTriageUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(mailTriageCorrection),
  });
};

export const getCorrectMailMessageTriageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof correctMailMessageTriage>>,
    TError,
    { id: string; data: BodyType<MailTriageCorrection> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof correctMailMessageTriage>>,
  TError,
  { id: string; data: BodyType<MailTriageCorrection> },
  TContext
> => {
  const mutationKey = ["correctMailMessageTriage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof correctMailMessageTriage>>,
    { id: string; data: BodyType<MailTriageCorrection> }
  > = (props) => {
    const { id, data } = props ?? {};

    return correctMailMessageTriage(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CorrectMailMessageTriageMutationResult = NonNullable<
  Awaited<ReturnType<typeof correctMailMessageTriage>>
>;
export type CorrectMailMessageTriageMutationBody =
  BodyType<MailTriageCorrection>;
export type CorrectMailMessageTriageMutationError = ErrorType<unknown>;

/**
 * @summary User correction of a triage label, optionally creating a learned rule.
 */
export const useCorrectMailMessageTriage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof correctMailMessageTriage>>,
    TError,
    { id: string; data: BodyType<MailTriageCorrection> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof correctMailMessageTriage>>,
  TError,
  { id: string; data: BodyType<MailTriageCorrection> },
  TContext
> => {
  return useMutation(getCorrectMailMessageTriageMutationOptions(options));
};

export const getListMailLearnedRulesUrl = (id: string) => {
  return `/api/mail/accounts/${id}/learned-rules`;
};

export const listMailLearnedRules = async (
  id: string,
  options?: RequestInit,
): Promise<MailLearnedRule[]> => {
  return customFetch<MailLearnedRule[]>(getListMailLearnedRulesUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListMailLearnedRulesQueryKey = (id: string) => {
  return [`/api/mail/accounts/${id}/learned-rules`] as const;
};

export const getListMailLearnedRulesQueryOptions = <
  TData = Awaited<ReturnType<typeof listMailLearnedRules>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMailLearnedRules>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListMailLearnedRulesQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMailLearnedRules>>
  > = ({ signal }) => listMailLearnedRules(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listMailLearnedRules>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMailLearnedRulesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMailLearnedRules>>
>;
export type ListMailLearnedRulesQueryError = ErrorType<unknown>;

export function useListMailLearnedRules<
  TData = Awaited<ReturnType<typeof listMailLearnedRules>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMailLearnedRules>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMailLearnedRulesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getCreateMailLearnedRuleUrl = (id: string) => {
  return `/api/mail/accounts/${id}/learned-rules`;
};

export const createMailLearnedRule = async (
  id: string,
  mailLearnedRuleInput: MailLearnedRuleInput,
  options?: RequestInit,
): Promise<MailLearnedRule> => {
  return customFetch<MailLearnedRule>(getCreateMailLearnedRuleUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(mailLearnedRuleInput),
  });
};

export const getCreateMailLearnedRuleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMailLearnedRule>>,
    TError,
    { id: string; data: BodyType<MailLearnedRuleInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createMailLearnedRule>>,
  TError,
  { id: string; data: BodyType<MailLearnedRuleInput> },
  TContext
> => {
  const mutationKey = ["createMailLearnedRule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createMailLearnedRule>>,
    { id: string; data: BodyType<MailLearnedRuleInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createMailLearnedRule(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateMailLearnedRuleMutationResult = NonNullable<
  Awaited<ReturnType<typeof createMailLearnedRule>>
>;
export type CreateMailLearnedRuleMutationBody = BodyType<MailLearnedRuleInput>;
export type CreateMailLearnedRuleMutationError = ErrorType<unknown>;

export const useCreateMailLearnedRule = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createMailLearnedRule>>,
    TError,
    { id: string; data: BodyType<MailLearnedRuleInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createMailLearnedRule>>,
  TError,
  { id: string; data: BodyType<MailLearnedRuleInput> },
  TContext
> => {
  return useMutation(getCreateMailLearnedRuleMutationOptions(options));
};

export const getDeleteMailLearnedRuleUrl = (
  accountId: string,
  ruleId: string,
) => {
  return `/api/mail/accounts/${accountId}/learned-rules/${ruleId}`;
};

export const deleteMailLearnedRule = async (
  accountId: string,
  ruleId: string,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getDeleteMailLearnedRuleUrl(accountId, ruleId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteMailLearnedRuleMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMailLearnedRule>>,
    TError,
    { accountId: string; ruleId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteMailLearnedRule>>,
  TError,
  { accountId: string; ruleId: string },
  TContext
> => {
  const mutationKey = ["deleteMailLearnedRule"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteMailLearnedRule>>,
    { accountId: string; ruleId: string }
  > = (props) => {
    const { accountId, ruleId } = props ?? {};

    return deleteMailLearnedRule(accountId, ruleId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteMailLearnedRuleMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteMailLearnedRule>>
>;

export type DeleteMailLearnedRuleMutationError = ErrorType<unknown>;

export const useDeleteMailLearnedRule = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteMailLearnedRule>>,
    TError,
    { accountId: string; ruleId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteMailLearnedRule>>,
  TError,
  { accountId: string; ruleId: string },
  TContext
> => {
  return useMutation(getDeleteMailLearnedRuleMutationOptions(options));
};

export const getListMailOldThreadCandidatesUrl = (id: string) => {
  return `/api/mail/accounts/${id}/old-thread-candidates`;
};

export const listMailOldThreadCandidates = async (
  id: string,
  options?: RequestInit,
): Promise<MailMessage[]> => {
  return customFetch<MailMessage[]>(getListMailOldThreadCandidatesUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListMailOldThreadCandidatesQueryKey = (id: string) => {
  return [`/api/mail/accounts/${id}/old-thread-candidates`] as const;
};

export const getListMailOldThreadCandidatesQueryOptions = <
  TData = Awaited<ReturnType<typeof listMailOldThreadCandidates>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMailOldThreadCandidates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListMailOldThreadCandidatesQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMailOldThreadCandidates>>
  > = ({ signal }) =>
    listMailOldThreadCandidates(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listMailOldThreadCandidates>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMailOldThreadCandidatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMailOldThreadCandidates>>
>;
export type ListMailOldThreadCandidatesQueryError = ErrorType<unknown>;

export function useListMailOldThreadCandidates<
  TData = Awaited<ReturnType<typeof listMailOldThreadCandidates>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMailOldThreadCandidates>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMailOldThreadCandidatesQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getResolveMailOldThreadCandidatesUrl = (id: string) => {
  return `/api/mail/accounts/${id}/old-thread-candidates/resolve`;
};

export const resolveMailOldThreadCandidates = async (
  id: string,
  mailOldThreadResolveBody: MailOldThreadResolveBody,
  options?: RequestInit,
): Promise<ResolveMailOldThreadCandidates200> => {
  return customFetch<ResolveMailOldThreadCandidates200>(
    getResolveMailOldThreadCandidatesUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(mailOldThreadResolveBody),
    },
  );
};

export const getResolveMailOldThreadCandidatesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolveMailOldThreadCandidates>>,
    TError,
    { id: string; data: BodyType<MailOldThreadResolveBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resolveMailOldThreadCandidates>>,
  TError,
  { id: string; data: BodyType<MailOldThreadResolveBody> },
  TContext
> => {
  const mutationKey = ["resolveMailOldThreadCandidates"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resolveMailOldThreadCandidates>>,
    { id: string; data: BodyType<MailOldThreadResolveBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return resolveMailOldThreadCandidates(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResolveMailOldThreadCandidatesMutationResult = NonNullable<
  Awaited<ReturnType<typeof resolveMailOldThreadCandidates>>
>;
export type ResolveMailOldThreadCandidatesMutationBody =
  BodyType<MailOldThreadResolveBody>;
export type ResolveMailOldThreadCandidatesMutationError = ErrorType<unknown>;

export const useResolveMailOldThreadCandidates = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resolveMailOldThreadCandidates>>,
    TError,
    { id: string; data: BodyType<MailOldThreadResolveBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resolveMailOldThreadCandidates>>,
  TError,
  { id: string; data: BodyType<MailOldThreadResolveBody> },
  TContext
> => {
  return useMutation(getResolveMailOldThreadCandidatesMutationOptions(options));
};

export const getPromoteMailMessageToProjectUrl = (id: string) => {
  return `/api/mail/messages/${id}/promote-to-project`;
};

export const promoteMailMessageToProject = async (
  id: string,
  mailPromoteToProjectBody: MailPromoteToProjectBody,
  options?: RequestInit,
): Promise<Project> => {
  return customFetch<Project>(getPromoteMailMessageToProjectUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(mailPromoteToProjectBody),
  });
};

export const getPromoteMailMessageToProjectMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoteMailMessageToProject>>,
    TError,
    { id: string; data: BodyType<MailPromoteToProjectBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof promoteMailMessageToProject>>,
  TError,
  { id: string; data: BodyType<MailPromoteToProjectBody> },
  TContext
> => {
  const mutationKey = ["promoteMailMessageToProject"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof promoteMailMessageToProject>>,
    { id: string; data: BodyType<MailPromoteToProjectBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return promoteMailMessageToProject(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PromoteMailMessageToProjectMutationResult = NonNullable<
  Awaited<ReturnType<typeof promoteMailMessageToProject>>
>;
export type PromoteMailMessageToProjectMutationBody =
  BodyType<MailPromoteToProjectBody>;
export type PromoteMailMessageToProjectMutationError = ErrorType<unknown>;

export const usePromoteMailMessageToProject = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof promoteMailMessageToProject>>,
    TError,
    { id: string; data: BodyType<MailPromoteToProjectBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof promoteMailMessageToProject>>,
  TError,
  { id: string; data: BodyType<MailPromoteToProjectBody> },
  TContext
> => {
  return useMutation(getPromoteMailMessageToProjectMutationOptions(options));
};

export const getListMailMessageSuggestionsUrl = (id: string) => {
  return `/api/mail/messages/${id}/suggestions`;
};

export const listMailMessageSuggestions = async (
  id: string,
  options?: RequestInit,
): Promise<SuggestedAction[]> => {
  return customFetch<SuggestedAction[]>(getListMailMessageSuggestionsUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getListMailMessageSuggestionsQueryKey = (id: string) => {
  return [`/api/mail/messages/${id}/suggestions`] as const;
};

export const getListMailMessageSuggestionsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMailMessageSuggestions>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMailMessageSuggestions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListMailMessageSuggestionsQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMailMessageSuggestions>>
  > = ({ signal }) =>
    listMailMessageSuggestions(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listMailMessageSuggestions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMailMessageSuggestionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMailMessageSuggestions>>
>;
export type ListMailMessageSuggestionsQueryError = ErrorType<unknown>;

export function useListMailMessageSuggestions<
  TData = Awaited<ReturnType<typeof listMailMessageSuggestions>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMailMessageSuggestions>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMailMessageSuggestionsQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetMailOldThreadCandidatesSummaryUrl = () => {
  return `/api/mail/old-thread-candidates/summary`;
};

export const getMailOldThreadCandidatesSummary = async (
  options?: RequestInit,
): Promise<MailOldThreadSummary> => {
  return customFetch<MailOldThreadSummary>(
    getGetMailOldThreadCandidatesSummaryUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetMailOldThreadCandidatesSummaryQueryKey = () => {
  return [`/api/mail/old-thread-candidates/summary`] as const;
};

export const getGetMailOldThreadCandidatesSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getMailOldThreadCandidatesSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMailOldThreadCandidatesSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetMailOldThreadCandidatesSummaryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getMailOldThreadCandidatesSummary>>
  > = ({ signal }) =>
    getMailOldThreadCandidatesSummary({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMailOldThreadCandidatesSummary>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetMailOldThreadCandidatesSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMailOldThreadCandidatesSummary>>
>;
export type GetMailOldThreadCandidatesSummaryQueryError = ErrorType<unknown>;

export function useGetMailOldThreadCandidatesSummary<
  TData = Awaited<ReturnType<typeof getMailOldThreadCandidatesSummary>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getMailOldThreadCandidatesSummary>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getGetMailOldThreadCandidatesSummaryQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Seed demo data for current user
 */
export const getSeedDemoUrl = () => {
  return `/api/seed-demo`;
};

export const seedDemo = async (
  options?: RequestInit,
): Promise<SeedResponse> => {
  return customFetch<SeedResponse>(getSeedDemoUrl(), {
    ...options,
    method: "POST",
  });
};

export const getSeedDemoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof seedDemo>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof seedDemo>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["seedDemo"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof seedDemo>>,
    void
  > = () => {
    return seedDemo(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SeedDemoMutationResult = NonNullable<
  Awaited<ReturnType<typeof seedDemo>>
>;

export type SeedDemoMutationError = ErrorType<unknown>;

/**
 * @summary Seed demo data for current user
 */
export const useSeedDemo = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof seedDemo>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof seedDemo>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getSeedDemoMutationOptions(options));
};

/**
 * @summary Get the current assistant conversation (last 100 messages, ≈50 exchanges)
 */
export const getGetAssistantConversationUrl = () => {
  return `/api/assistant/conversation`;
};

export const getAssistantConversation = async (
  options?: RequestInit,
): Promise<AssistantConversation> => {
  return customFetch<AssistantConversation>(getGetAssistantConversationUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAssistantConversationQueryKey = () => {
  return [`/api/assistant/conversation`] as const;
};

export const getGetAssistantConversationQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssistantConversation>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAssistantConversation>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssistantConversationQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssistantConversation>>
  > = ({ signal }) => getAssistantConversation({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssistantConversation>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAssistantConversationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssistantConversation>>
>;
export type GetAssistantConversationQueryError = ErrorType<unknown>;

/**
 * @summary Get the current assistant conversation (last 100 messages, ≈50 exchanges)
 */

export function useGetAssistantConversation<
  TData = Awaited<ReturnType<typeof getAssistantConversation>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAssistantConversation>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAssistantConversationQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Send a user message and get the assistant reply
 */
export const getSendAssistantMessageUrl = () => {
  return `/api/assistant/messages`;
};

export const sendAssistantMessage = async (
  assistantSendMessageBody: AssistantSendMessageBody,
  options?: RequestInit,
): Promise<AssistantSendMessageResponse> => {
  return customFetch<AssistantSendMessageResponse>(
    getSendAssistantMessageUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(assistantSendMessageBody),
    },
  );
};

export const getSendAssistantMessageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendAssistantMessage>>,
    TError,
    { data: BodyType<AssistantSendMessageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendAssistantMessage>>,
  TError,
  { data: BodyType<AssistantSendMessageBody> },
  TContext
> => {
  const mutationKey = ["sendAssistantMessage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendAssistantMessage>>,
    { data: BodyType<AssistantSendMessageBody> }
  > = (props) => {
    const { data } = props ?? {};

    return sendAssistantMessage(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendAssistantMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendAssistantMessage>>
>;
export type SendAssistantMessageMutationBody =
  BodyType<AssistantSendMessageBody>;
export type SendAssistantMessageMutationError = ErrorType<unknown>;

/**
 * @summary Send a user message and get the assistant reply
 */
export const useSendAssistantMessage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendAssistantMessage>>,
    TError,
    { data: BodyType<AssistantSendMessageBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendAssistantMessage>>,
  TError,
  { data: BodyType<AssistantSendMessageBody> },
  TContext
> => {
  return useMutation(getSendAssistantMessageMutationOptions(options));
};

/**
 * @summary Wipe the conversation thread
 */
export const getResetAssistantConversationUrl = () => {
  return `/api/assistant/new-conversation`;
};

export const resetAssistantConversation = async (
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getResetAssistantConversationUrl(), {
    ...options,
    method: "POST",
  });
};

export const getResetAssistantConversationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetAssistantConversation>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetAssistantConversation>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["resetAssistantConversation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetAssistantConversation>>,
    void
  > = () => {
    return resetAssistantConversation(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetAssistantConversationMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetAssistantConversation>>
>;

export type ResetAssistantConversationMutationError = ErrorType<unknown>;

/**
 * @summary Wipe the conversation thread
 */
export const useResetAssistantConversation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetAssistantConversation>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resetAssistantConversation>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getResetAssistantConversationMutationOptions(options));
};

/**
 * @summary List deterministic insights (optional AI rephrasing layer applied per-call)
 */
export const getListAssistantInsightsUrl = () => {
  return `/api/assistant/insights`;
};

export const listAssistantInsights = async (
  options?: RequestInit,
): Promise<AssistantInsightsResponse> => {
  return customFetch<AssistantInsightsResponse>(getListAssistantInsightsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListAssistantInsightsQueryKey = () => {
  return [`/api/assistant/insights`] as const;
};

export const getListAssistantInsightsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAssistantInsights>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAssistantInsights>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAssistantInsightsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listAssistantInsights>>
  > = ({ signal }) => listAssistantInsights({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listAssistantInsights>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListAssistantInsightsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAssistantInsights>>
>;
export type ListAssistantInsightsQueryError = ErrorType<unknown>;

/**
 * @summary List deterministic insights (optional AI rephrasing layer applied per-call)
 */

export function useListAssistantInsights<
  TData = Awaited<ReturnType<typeof listAssistantInsights>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listAssistantInsights>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListAssistantInsightsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Snooze an insight by key
 */
export const getSnoozeAssistantInsightUrl = () => {
  return `/api/assistant/insights/snooze`;
};

export const snoozeAssistantInsight = async (
  assistantSnoozeBody: AssistantSnoozeBody,
  options?: RequestInit,
): Promise<OkResponse> => {
  return customFetch<OkResponse>(getSnoozeAssistantInsightUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(assistantSnoozeBody),
  });
};

export const getSnoozeAssistantInsightMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof snoozeAssistantInsight>>,
    TError,
    { data: BodyType<AssistantSnoozeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof snoozeAssistantInsight>>,
  TError,
  { data: BodyType<AssistantSnoozeBody> },
  TContext
> => {
  const mutationKey = ["snoozeAssistantInsight"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof snoozeAssistantInsight>>,
    { data: BodyType<AssistantSnoozeBody> }
  > = (props) => {
    const { data } = props ?? {};

    return snoozeAssistantInsight(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SnoozeAssistantInsightMutationResult = NonNullable<
  Awaited<ReturnType<typeof snoozeAssistantInsight>>
>;
export type SnoozeAssistantInsightMutationBody = BodyType<AssistantSnoozeBody>;
export type SnoozeAssistantInsightMutationError = ErrorType<unknown>;

/**
 * @summary Snooze an insight by key
 */
export const useSnoozeAssistantInsight = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof snoozeAssistantInsight>>,
    TError,
    { data: BodyType<AssistantSnoozeBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof snoozeAssistantInsight>>,
  TError,
  { data: BodyType<AssistantSnoozeBody> },
  TContext
> => {
  return useMutation(getSnoozeAssistantInsightMutationOptions(options));
};

/**
 * @summary Generate or fetch today's morning briefing
 */
export const getGetAssistantBriefingUrl = () => {
  return `/api/assistant/briefing`;
};

export const getAssistantBriefing = async (
  options?: RequestInit,
): Promise<AssistantBriefingResponse> => {
  return customFetch<AssistantBriefingResponse>(getGetAssistantBriefingUrl(), {
    ...options,
    method: "POST",
  });
};

export const getGetAssistantBriefingMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAssistantBriefing>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getAssistantBriefing>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["getAssistantBriefing"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getAssistantBriefing>>,
    void
  > = () => {
    return getAssistantBriefing(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetAssistantBriefingMutationResult = NonNullable<
  Awaited<ReturnType<typeof getAssistantBriefing>>
>;

export type GetAssistantBriefingMutationError = ErrorType<unknown>;

/**
 * @summary Generate or fetch today's morning briefing
 */
export const useGetAssistantBriefing = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getAssistantBriefing>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof getAssistantBriefing>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getGetAssistantBriefingMutationOptions(options));
};

/**
 * @summary Start a batch analyze job (returns jobId immediately, work runs in background)
 */
export const getAssistantAnalyzeNowUrl = () => {
  return `/api/assistant/analyze-now`;
};

export const assistantAnalyzeNow = async (
  assistantAnalyzeNowBody?: AssistantAnalyzeNowBody,
  options?: RequestInit,
): Promise<AssistantAnalyzeNowResponse> => {
  return customFetch<AssistantAnalyzeNowResponse>(getAssistantAnalyzeNowUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(assistantAnalyzeNowBody),
  });
};

export const getAssistantAnalyzeNowMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assistantAnalyzeNow>>,
    TError,
    { data: BodyType<AssistantAnalyzeNowBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assistantAnalyzeNow>>,
  TError,
  { data: BodyType<AssistantAnalyzeNowBody> },
  TContext
> => {
  const mutationKey = ["assistantAnalyzeNow"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assistantAnalyzeNow>>,
    { data: BodyType<AssistantAnalyzeNowBody> }
  > = (props) => {
    const { data } = props ?? {};

    return assistantAnalyzeNow(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssistantAnalyzeNowMutationResult = NonNullable<
  Awaited<ReturnType<typeof assistantAnalyzeNow>>
>;
export type AssistantAnalyzeNowMutationBody = BodyType<AssistantAnalyzeNowBody>;
export type AssistantAnalyzeNowMutationError = ErrorType<unknown>;

/**
 * @summary Start a batch analyze job (returns jobId immediately, work runs in background)
 */
export const useAssistantAnalyzeNow = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assistantAnalyzeNow>>,
    TError,
    { data: BodyType<AssistantAnalyzeNowBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof assistantAnalyzeNow>>,
  TError,
  { data: BodyType<AssistantAnalyzeNowBody> },
  TContext
> => {
  return useMutation(getAssistantAnalyzeNowMutationOptions(options));
};

/**
 * @summary Poll the progress of an analyze-now job
 */
export const getGetAssistantAnalyzeJobUrl = (jobId: string) => {
  return `/api/assistant/analyze-now/jobs/${jobId}`;
};

export const getAssistantAnalyzeJob = async (
  jobId: string,
  options?: RequestInit,
): Promise<AssistantAnalyzeJobStatus> => {
  return customFetch<AssistantAnalyzeJobStatus>(
    getGetAssistantAnalyzeJobUrl(jobId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAssistantAnalyzeJobQueryKey = (jobId: string) => {
  return [`/api/assistant/analyze-now/jobs/${jobId}`] as const;
};

export const getGetAssistantAnalyzeJobQueryOptions = <
  TData = Awaited<ReturnType<typeof getAssistantAnalyzeJob>>,
  TError = ErrorType<void>,
>(
  jobId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAssistantAnalyzeJob>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAssistantAnalyzeJobQueryKey(jobId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAssistantAnalyzeJob>>
  > = ({ signal }) =>
    getAssistantAnalyzeJob(jobId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!jobId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAssistantAnalyzeJob>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAssistantAnalyzeJobQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAssistantAnalyzeJob>>
>;
export type GetAssistantAnalyzeJobQueryError = ErrorType<void>;

/**
 * @summary Poll the progress of an analyze-now job
 */

export function useGetAssistantAnalyzeJob<
  TData = Awaited<ReturnType<typeof getAssistantAnalyzeJob>>,
  TError = ErrorType<void>,
>(
  jobId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAssistantAnalyzeJob>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAssistantAnalyzeJobQueryOptions(jobId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Pause an in-flight analyze-now job (only meaningful during the syncing phase)
 */
export const getPauseAssistantAnalyzeJobUrl = (jobId: string) => {
  return `/api/assistant/analyze-now/jobs/${jobId}/pause`;
};

export const pauseAssistantAnalyzeJob = async (
  jobId: string,
  options?: RequestInit,
): Promise<AssistantAnalyzeJobControlResponse> => {
  return customFetch<AssistantAnalyzeJobControlResponse>(
    getPauseAssistantAnalyzeJobUrl(jobId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getPauseAssistantAnalyzeJobMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pauseAssistantAnalyzeJob>>,
    TError,
    { jobId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof pauseAssistantAnalyzeJob>>,
  TError,
  { jobId: string },
  TContext
> => {
  const mutationKey = ["pauseAssistantAnalyzeJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof pauseAssistantAnalyzeJob>>,
    { jobId: string }
  > = (props) => {
    const { jobId } = props ?? {};

    return pauseAssistantAnalyzeJob(jobId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PauseAssistantAnalyzeJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof pauseAssistantAnalyzeJob>>
>;

export type PauseAssistantAnalyzeJobMutationError = ErrorType<void>;

/**
 * @summary Pause an in-flight analyze-now job (only meaningful during the syncing phase)
 */
export const usePauseAssistantAnalyzeJob = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof pauseAssistantAnalyzeJob>>,
    TError,
    { jobId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof pauseAssistantAnalyzeJob>>,
  TError,
  { jobId: string },
  TContext
> => {
  return useMutation(getPauseAssistantAnalyzeJobMutationOptions(options));
};

/**
 * @summary Resume a paused analyze-now job
 */
export const getResumeAssistantAnalyzeJobUrl = (jobId: string) => {
  return `/api/assistant/analyze-now/jobs/${jobId}/resume`;
};

export const resumeAssistantAnalyzeJob = async (
  jobId: string,
  options?: RequestInit,
): Promise<AssistantAnalyzeJobControlResponse> => {
  return customFetch<AssistantAnalyzeJobControlResponse>(
    getResumeAssistantAnalyzeJobUrl(jobId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getResumeAssistantAnalyzeJobMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resumeAssistantAnalyzeJob>>,
    TError,
    { jobId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resumeAssistantAnalyzeJob>>,
  TError,
  { jobId: string },
  TContext
> => {
  const mutationKey = ["resumeAssistantAnalyzeJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resumeAssistantAnalyzeJob>>,
    { jobId: string }
  > = (props) => {
    const { jobId } = props ?? {};

    return resumeAssistantAnalyzeJob(jobId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResumeAssistantAnalyzeJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof resumeAssistantAnalyzeJob>>
>;

export type ResumeAssistantAnalyzeJobMutationError = ErrorType<void>;

/**
 * @summary Resume a paused analyze-now job
 */
export const useResumeAssistantAnalyzeJob = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resumeAssistantAnalyzeJob>>,
    TError,
    { jobId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resumeAssistantAnalyzeJob>>,
  TError,
  { jobId: string },
  TContext
> => {
  return useMutation(getResumeAssistantAnalyzeJobMutationOptions(options));
};

/**
 * @summary Cancel an in-flight analyze-now job (idempotent)
 */
export const getCancelAssistantAnalyzeJobUrl = (jobId: string) => {
  return `/api/assistant/analyze-now/jobs/${jobId}/cancel`;
};

export const cancelAssistantAnalyzeJob = async (
  jobId: string,
  options?: RequestInit,
): Promise<AssistantAnalyzeJobControlResponse> => {
  return customFetch<AssistantAnalyzeJobControlResponse>(
    getCancelAssistantAnalyzeJobUrl(jobId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getCancelAssistantAnalyzeJobMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelAssistantAnalyzeJob>>,
    TError,
    { jobId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cancelAssistantAnalyzeJob>>,
  TError,
  { jobId: string },
  TContext
> => {
  const mutationKey = ["cancelAssistantAnalyzeJob"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cancelAssistantAnalyzeJob>>,
    { jobId: string }
  > = (props) => {
    const { jobId } = props ?? {};

    return cancelAssistantAnalyzeJob(jobId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CancelAssistantAnalyzeJobMutationResult = NonNullable<
  Awaited<ReturnType<typeof cancelAssistantAnalyzeJob>>
>;

export type CancelAssistantAnalyzeJobMutationError = ErrorType<void>;

/**
 * @summary Cancel an in-flight analyze-now job (idempotent)
 */
export const useCancelAssistantAnalyzeJob = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cancelAssistantAnalyzeJob>>,
    TError,
    { jobId: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof cancelAssistantAnalyzeJob>>,
  TError,
  { jobId: string },
  TContext
> => {
  return useMutation(getCancelAssistantAnalyzeJobMutationOptions(options));
};

/**
 * @summary Current plan, AI credit balance and catalogue
 */
export const getGetBillingMeUrl = () => {
  return `/api/billing/me`;
};

export const getBillingMe = async (
  options?: RequestInit,
): Promise<BillingState> => {
  return customFetch<BillingState>(getGetBillingMeUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetBillingMeQueryKey = () => {
  return [`/api/billing/me`] as const;
};

export const getGetBillingMeQueryOptions = <
  TData = Awaited<ReturnType<typeof getBillingMe>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBillingMe>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBillingMeQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBillingMe>>> = ({
    signal,
  }) => getBillingMe({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBillingMe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetBillingMeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBillingMe>>
>;
export type GetBillingMeQueryError = ErrorType<unknown>;

/**
 * @summary Current plan, AI credit balance and catalogue
 */

export function useGetBillingMe<
  TData = Awaited<ReturnType<typeof getBillingMe>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBillingMe>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetBillingMeQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Switch to a new plan (fake billing — no real payment)
 */
export const getUpgradePlanUrl = () => {
  return `/api/billing/upgrade`;
};

export const upgradePlan = async (
  upgradePlanBody: UpgradePlanBody,
  options?: RequestInit,
): Promise<BillingState> => {
  return customFetch<BillingState>(getUpgradePlanUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(upgradePlanBody),
  });
};

export const getUpgradePlanMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upgradePlan>>,
    TError,
    { data: BodyType<UpgradePlanBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upgradePlan>>,
  TError,
  { data: BodyType<UpgradePlanBody> },
  TContext
> => {
  const mutationKey = ["upgradePlan"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upgradePlan>>,
    { data: BodyType<UpgradePlanBody> }
  > = (props) => {
    const { data } = props ?? {};

    return upgradePlan(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpgradePlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof upgradePlan>>
>;
export type UpgradePlanMutationBody = BodyType<UpgradePlanBody>;
export type UpgradePlanMutationError = ErrorType<unknown>;

/**
 * @summary Switch to a new plan (fake billing — no real payment)
 */
export const useUpgradePlan = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upgradePlan>>,
    TError,
    { data: BodyType<UpgradePlanBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof upgradePlan>>,
  TError,
  { data: BodyType<UpgradePlanBody> },
  TContext
> => {
  return useMutation(getUpgradePlanMutationOptions(options));
};

/**
 * @summary Add a credit pack to the user's balance (fake billing)
 */
export const getBuyCreditsUrl = () => {
  return `/api/billing/buy-credits`;
};

export const buyCredits = async (
  buyCreditsBody: BuyCreditsBody,
  options?: RequestInit,
): Promise<BillingState> => {
  return customFetch<BillingState>(getBuyCreditsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(buyCreditsBody),
  });
};

export const getBuyCreditsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof buyCredits>>,
    TError,
    { data: BodyType<BuyCreditsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof buyCredits>>,
  TError,
  { data: BodyType<BuyCreditsBody> },
  TContext
> => {
  const mutationKey = ["buyCredits"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof buyCredits>>,
    { data: BodyType<BuyCreditsBody> }
  > = (props) => {
    const { data } = props ?? {};

    return buyCredits(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BuyCreditsMutationResult = NonNullable<
  Awaited<ReturnType<typeof buyCredits>>
>;
export type BuyCreditsMutationBody = BodyType<BuyCreditsBody>;
export type BuyCreditsMutationError = ErrorType<unknown>;

/**
 * @summary Add a credit pack to the user's balance (fake billing)
 */
export const useBuyCredits = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof buyCredits>>,
    TError,
    { data: BodyType<BuyCreditsBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof buyCredits>>,
  TError,
  { data: BodyType<BuyCreditsBody> },
  TContext
> => {
  return useMutation(getBuyCreditsMutationOptions(options));
};

/**
 * @summary List the current user's billing events (paginated)
 */
export const getListMyBillingEventsUrl = (
  params?: ListMyBillingEventsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/billing/events?${stringifiedParams}`
    : `/api/billing/events`;
};

export const listMyBillingEvents = async (
  params?: ListMyBillingEventsParams,
  options?: RequestInit,
): Promise<BillingEventsPage> => {
  return customFetch<BillingEventsPage>(getListMyBillingEventsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListMyBillingEventsQueryKey = (
  params?: ListMyBillingEventsParams,
) => {
  return [`/api/billing/events`, ...(params ? [params] : [])] as const;
};

export const getListMyBillingEventsQueryOptions = <
  TData = Awaited<ReturnType<typeof listMyBillingEvents>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMyBillingEventsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMyBillingEvents>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListMyBillingEventsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMyBillingEvents>>
  > = ({ signal }) =>
    listMyBillingEvents(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listMyBillingEvents>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListMyBillingEventsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMyBillingEvents>>
>;
export type ListMyBillingEventsQueryError = ErrorType<unknown>;

/**
 * @summary List the current user's billing events (paginated)
 */

export function useListMyBillingEvents<
  TData = Awaited<ReturnType<typeof listMyBillingEvents>>,
  TError = ErrorType<unknown>,
>(
  params?: ListMyBillingEventsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof listMyBillingEvents>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListMyBillingEventsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Execute an action card from an assistant message
 */
export const getExecuteAssistantCardUrl = () => {
  return `/api/assistant/cards/execute`;
};

export const executeAssistantCard = async (
  assistantExecuteCardBody: AssistantExecuteCardBody,
  options?: RequestInit,
): Promise<AssistantExecuteCardResponse> => {
  return customFetch<AssistantExecuteCardResponse>(
    getExecuteAssistantCardUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(assistantExecuteCardBody),
    },
  );
};

export const getExecuteAssistantCardMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof executeAssistantCard>>,
    TError,
    { data: BodyType<AssistantExecuteCardBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof executeAssistantCard>>,
  TError,
  { data: BodyType<AssistantExecuteCardBody> },
  TContext
> => {
  const mutationKey = ["executeAssistantCard"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof executeAssistantCard>>,
    { data: BodyType<AssistantExecuteCardBody> }
  > = (props) => {
    const { data } = props ?? {};

    return executeAssistantCard(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ExecuteAssistantCardMutationResult = NonNullable<
  Awaited<ReturnType<typeof executeAssistantCard>>
>;
export type ExecuteAssistantCardMutationBody =
  BodyType<AssistantExecuteCardBody>;
export type ExecuteAssistantCardMutationError = ErrorType<unknown>;

/**
 * @summary Execute an action card from an assistant message
 */
export const useExecuteAssistantCard = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof executeAssistantCard>>,
    TError,
    { data: BodyType<AssistantExecuteCardBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof executeAssistantCard>>,
  TError,
  { data: BodyType<AssistantExecuteCardBody> },
  TContext
> => {
  return useMutation(getExecuteAssistantCardMutationOptions(options));
};
